<template>
    <div>
        <div>
            <h5 class="font-weight-bold">{{$t('accommodation.roomPrice')}}</h5>
            <hr />
            <div class="row">
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.single') }}</label>
                    <input type="text" class="form-control" readonly v-model="accommodation.single">
                </div>
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.double') }}</label>
                    <input type="text" class="form-control" readonly v-model="accommodation.double">
                </div>
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.triple') }}</label>
                    <input type="text" class="form-control" readonly v-model="accommodation.triple">
                </div>
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.apartment') }}</label>
                    <input type="text" class="form-control" readonly v-model="accommodation.apartment">
                </div>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="form-group col-lg-6">
                <label class="font-weight-bold">{{ $t('accommodation.food') }}</label>
                <toggle v-model="accommodation.food" :disabled="true"></toggle>
            </div>
            <div v-if="accommodation.food" class="form-group col-lg-6">
                <label class="font-weight-bold">{{ $t('accommodation.menu') }}</label>
                <input type="text" class="form-control" readonly v-model="accommodation.menuTypes">
            </div>
        </div>
    </div>
</template>

<script>
    import appToggle from '../toggle/Toggle';

    export default {
        props: {
            accommodation: {
                type: Object
            }
        },
        data() {
            return {
            }
        },
        components: {
            'toggle': appToggle,
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
